// @mui
import type { TextFieldProps } from '@mui/material';

import { TextField } from '@mui/material';
// form
import { Controller, useFormContext } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  name: string;
} & TextFieldProps;

const RHFTextField = ({ helperText, name, ...other }: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          error={!!error}
          fullWidth
          helperText={error ? error?.message : helperText}
          value={
            typeof field.value === 'number' && field.value === 0
              ? ''
              : field.value
          }
          {...other}
        />
      )}
    />
  );
};

export default RHFTextField;
